import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CircularProgress } from '@mui/material';
import TextField from '@mui/material/TextField';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import { FormControl, InputAdornment, InputLabel, MenuItem, Select } from '@mui/material';

import { vehicleTypeOptions, makeOptions } from '../../utils/vehicleTypes';
import { createSetup, addBasicDetails } from '../../features/fueladmin/fuelSlice';
import { useridSelector } from '../../features/user/UserSlice';

const FuelBasicForm = ({ assetId, assetData }) => {

    //vehicleName, userid, noOfSensors, noOfTanks, vehicleType, make, model
    const dispatch = useDispatch();

    const userid = useSelector(useridSelector);
    const [loading, setLoading] = useState(false);
    const [vehicleType, setvehicleType] = useState("");
    const [make, setMake] = useState("");
    const [model, setModel] = useState("");
    const [noOfTanks, setNoOfTanks] = useState(1);
    const [noOfSensors, setNoOfSensors] = useState(1);

    const handleSubmit = () => {

        setLoading(true);
        dispatch(addBasicDetails({
            assetId, vehicleName: assetData.vehicleDevice.regn, userid, noOfSensors, noOfTanks, vehicleType, make, model
        }));
        dispatch(createSetup({
            assetId, vehicleName: assetData.vehicleDevice.regn, userid, noOfSensors, noOfTanks, vehicleType, make, model
        }));

    }


    return (
        <Card>
            <CardContent>
                {
                    loading ? <CircularProgress /> :

                        <div>
                            <FormControl sx={{ m: 1, width: '25ch' }} >
                                <InputLabel id="vehicleType">Vehicle Type?</InputLabel>
                                <Select
                                    variant="standard"
                                    id="vehicleType"
                                    value={vehicleType}
                                    onChange={(e) => setvehicleType(e.target.value)}
                                >
                                    {
                                        vehicleTypeOptions.map(ev => <MenuItem key={ev} value={ev}>{ev}</MenuItem>)
                                    }
                                </Select>
                            </FormControl>
                            <FormControl sx={{ m: 1, width: '45ch' }} >
                                <InputLabel id="vehicleType">Vehicle Make?</InputLabel>
                                <Select
                                    variant="standard"
                                    id="make"
                                    value={make}
                                    onChange={(e) => setMake(e.target.value)}
                                >
                                    {
                                        makeOptions.map(ev => <MenuItem key={ev} value={ev}>{ev}</MenuItem>)
                                    }
                                </Select>
                            </FormControl>

                            <FormControl sx={{ m: 1, width: '23ch' }} >
                                <TextField
                                    label="Model?"
                                    id="model"
                                    value={model}
                                    onChange={(e) => setModel(e.target.value)}
                                    sx={{ m: 1, width: '22ch' }}
                                    variant="standard"
                                />
                            </FormControl>
                            <FormControl sx={{ m: 1, width: '23ch' }} >
                                <TextField
                                    label="No of Sensors?"
                                    id="noOfSensors"
                                    value={noOfSensors}
                                    onChange={(e) => setNoOfSensors(e.target.value)}
                                    sx={{ m: 1, width: '22ch' }}
                                    InputProps={{
                                        startAdornment: <InputAdornment position="start">Sensors: </InputAdornment>,
                                    }}
                                    variant="standard"
                                    type="number"
                                />
                            </FormControl>
                            <FormControl sx={{ m: 1, width: '23ch' }} >
                                <TextField
                                    label="No of Tanks?"
                                    id="noOfTanks"
                                    sx={{ m: 1, width: '22ch' }}
                                    value={noOfTanks}
                                    onChange={(e) => setNoOfTanks(e.target.value)}
                                    InputProps={{
                                        startAdornment: <InputAdornment position="start">Tanks: </InputAdornment>,
                                    }}
                                    variant="standard"
                                    type="number"
                                />
                            </FormControl>
                        </div>
                }
            </CardContent>
            <CardActions>
                <Button onClick={handleSubmit}>Save & Next</Button>
            </CardActions>
        </Card>
    );
}

export default FuelBasicForm;